import React, { useCallback, useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import "./ReadMatch.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons'
import ReactPlayer from 'react-player'
import { createMetrics, updateMetrics } from "../service/service";
import { getMetricsWithFallback } from "../helpers/progressFallback";
import Modal from "../components/Modal";
import LessonInstruction from "../containers/instruction/LessonInstruction";
import { useAppGlobalConfig } from "../providers/AppGlobalConfigContext";
import {getBrowser, getOS} from "../lib/utils";

const Container = props => {
  const [playing, setPlaying] = useState(false);
  const [songPlaying, setSongPlaying] = useState('');
  const [dustbins, setDustbins] = useState([]);
  const [dustbinsAnswers, setDustbinsAnswers] = useState([]);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [btnModalText, setBtnModalText] = useState("Tentar novamente");
  const [modalErrorMsg, setModalErrorMsg] = useState("Erro ao registrar seu progresso. Clique no botão abaixo para tentar novamente");
  const [initTime, setInitTime] = useState(Date.now())
  const [metrics, setMetrics] = useState(null)
  const [totalAttemptsSum, setTotalAttemptsSum] = useState(null)
  const {isEmbedMode} = useAppGlobalConfig();
  let tenant = isEmbedMode ? 'cupheadless' : 'cupfranchise'

  const { bookName, totalIndexes, lessonId, blockData, blockIndex, step, audioUrl } = props;
  const userInfo = JSON.parse(localStorage.getItem("user-info"));

  const onDragEnd = async (result) => {
      if (!result.destination) {
        return;
      }

    const questionItem = dustbins.filter(i => Number(result.destination.droppableId) === i.id)[0];
    if (Number(result.destination.droppableId) === result.source.index) {
      playAudio(questionItem.sound, questionItem.sound_mp3);
      const destIndex = dustbins.indexOf(questionItem);
      questionItem.isEnabled = true;
      questionItem.en = questionItem.en.replace('/', '');
      dustbins[destIndex] = questionItem;;

      setDustbins(dustbins);
      setDustbinsAnswers(dustbinsAnswers.filter(i => result.source.index !== i.id))
    }
  }
  const onPlayingFalse = () => {
    setPlaying(false);
  }
  const playAudio = (sound, sound_mp3) => {
    let songPlaying = '';
    if (getBrowser() === 'Safari' || getOS() === 'iOS') {
      songPlaying = `${process.env.REACT_APP_CLOUDFRONT_DNS}/media/audios/` + sound_mp3
    } else {
      songPlaying = `${process.env.REACT_APP_CLOUDFRONT_DNS}/media/audios/` + sound
    }

    setSongPlaying(songPlaying);
    setPlaying(true);
  }

  const closeModal = () => {
    setModalOpen(false);
    step('forward', true);
  };

  const buttonModalAction = async () => {
    setIsLoading(true);
    setBtnModalText('Enviando...');
    try {
      await registerProgress()
      setModalOpen(false);
      step('forward', true)
    } catch (error) {
      setModalErrorMsg("O erro ainda continua.. Tente novamente ou clique no botão de fechar para avançar para a próxima lição")
    }
    setIsLoading(false);
    setBtnModalText('Tentar novamente');
  };

  const registerProgress = async () => {
    const params = {
      "userId": userInfo.id,
      "blockId": blockData.block_id,
      "template": "read_and_match",
      "bookName": bookName,
      "lessonId": lessonId,
      "scores": [{
        "isRight": true,
        "accuracy": 100,
        "elapsedTime": Date.now() - initTime,
        "dateTime": new Date(initTime).toISOString(),
        "totalAttempts": 1
      }],
      "sectionId": blockData.sectionId,
      "section": blockData.section,
      "index": blockData.num,
      "totalIndexes": totalIndexes
    }

    if (metrics) {
      await updateMetrics(params, tenant)
    } else {
      await createMetrics(params, tenant)
    }
  }

  const getMetricsData = useCallback(async () => {
    try {
      const resp = await getMetricsWithFallback(userInfo.id, blockData.block_id, tenant)
      const data = resp && resp.data;
      if (data && !data.notFound) {
        setMetrics(data)
        setTotalAttemptsSum((Array.isArray(data.scores) ? data.scores : []).reduce(
          (accumulator, currentValue) => accumulator + (currentValue.totalAttempts || 0), 0))
      } else {
        setMetrics(null)
        setTotalAttemptsSum(0)
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setMetrics(null)
        setTotalAttemptsSum(0)
      } else {
        console.error("Erro ao buscar métricas:", error);
      }
    }
  }, [blockIndex]);

  useEffect(() => {
    const sendData = async () => {
      try {
        await registerProgress()
      } catch (error) {
        setModalOpen(true);
      }
    }
    if (dustbins.length !== 0 && dustbinsAnswers.length === 0) {
      sendData()
    }
  }, [dustbins, dustbinsAnswers]);

  useEffect(() => {
    getMetricsData();
  }, [blockIndex]);

  useEffect(() => {
    let includelastDroppedItem = props.blockData.content.map(function (value, index) {
      value.isEnabled = false;
      value.lastDroppedItem = null;
      if (!value.shuffleOrder) {
        value.shuffleOrder = Math.floor(Math.random() * 100)
      }
      return { ...value };
    });
    let filteredIncludelastDroppedItem = includelastDroppedItem.filter((arr, index) => {
      return arr.type !== "instruction";
    });
    setDustbins(filteredIncludelastDroppedItem);
    setDustbinsAnswers(filteredIncludelastDroppedItem);
  }, [props.blockData.content]);

  if (props.blockData.content[props.contentIndex].type === "instruction") {
    return (
      <>
        <div className="new-bg-color">
          <LessonInstruction
            instructionText={props.blockData.content[props.contentIndex].instruction}
            audioUrl={`${process.env.REACT_APP_CLOUDFRONT_DNS}/media/audios/` + blockData.content[props.contentIndex].sound}
          />
        </div>
      </>
    )
  }

  return (
    <>
      <Modal isOpen={isModalOpen}
        onClose={closeModal}
        isLoading={isLoading}
        onActionButtonClick={buttonModalAction}
        message={modalErrorMsg}
        actionButtonText={btnModalText} />
      <DragDropContext
        className="container"
        onDragEnd={onDragEnd}
      >
        <ReactPlayer
          url={songPlaying}
          width={0}
          height={0}
          onEnded={onPlayingFalse}
          playing={playing}
        />
        <div className="cardsContainer">
          {dustbins.map(({ id, en, sound, sound_mp3, isEnabled }, index) => (

            <Droppable
              droppableId={`${id}`}
              key={`droppable-question-${index}`}
            >
              {(provided, snapshot) => (
                <div>
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    className="dustbinCard"
                    style={{
                      backgroundColor: snapshot.isDraggingOver ? "lightblue" : "white"
                    }}
                  >
                    {en.split('/')[0]}
                  </div>
                  {isEnabled && (
                    <div id={`audio-${id}`} className="audio-container" onClick={() => {
                      playAudio(`${sound}`, `${sound_mp3}`);
                    }}>
                      <div className="audio-icon" style={readMatchStyles.boxIcon}>
                        <FontAwesomeIcon className="icon-step" icon={faVolumeUp} style={readMatchStyles.iconWidth} />
                      </div>
                    </div>
                  )}
                  {!isEnabled && (
                    <div id={`off-${id}`} className="audio-container">
                      <div className="audio-icon" style={readMatchStyles.boxIconOff} >
                        <FontAwesomeIcon className="icon-step" icon={faVolumeUp} style={readMatchStyles.iconWidth} />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </Droppable>
          ))}

        </div>
        <hr />
        <Droppable
          droppableId="droppable-answers"
          key="droppable-answers"
        >
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="cardsContainer"
            >
              {provided.placeholder}
              {dustbinsAnswers.map(({ id, en, shuffleOrder }, index) => {
                return <Draggable
                  key={index}
                  draggableId={`draggable-${index}`}
                  index={id}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="dustbinCard"
                      style={{
                        order: shuffleOrder,
                        backgroundColor: snapshot.isDragging ? "lightblue" : "white",
                        ...provided.draggableProps.style
                      }}
                    >
                      {en.split('/')[1] || "Resposta não cadastrada, favor contactar o administrador"}
                    </div>
                  )}
                </Draggable>
              })}
            </div>
          )}
        </Droppable>
      </DragDropContext >
    </>
  );
};
export default Container;

const readMatchStyles = {
  playOff: {
    'backgroundColor': '#CCC',
  },
  iconWidth: {
    'fontSize': '15px',
  },
  boxIcon: {
    'width': '30px',
    'height': '30px',
  },
  boxIconOff: {
    'width': '30px',
    'height': '30px',
    'backgroundColor': '#CCC'
  }
};